import { SET_BRAND } from '../actions/brandActions';

// The school's accent colour and logo URL (relative to the API), or null for
// the SimulAlert defaults. Persisted, so a reload paints in the school's
// colours before the brand is fetched again.
const initialState = {
  accentColor: null,
  logoUrl: null
};

const brand = (state = initialState, action) => {
  switch (action.type) {
    case SET_BRAND:
      return {
        accentColor: action.accentColor,
        logoUrl: action.logoUrl
      };
    default:
      return state;
  }
};

export default brand;
